import { Flex } from '@mantine/core';
import { useParams } from 'react-router';
import { useEpic } from '../../../api/tasks-client/tasks-client.hooks';
import { H2 } from '../../../ui-library/typography/typography';

export const EpicDetailsControlBar = () => {
  const { id } = useParams();
  const { epic } = useEpic(id);

  return (
    <Flex align="center" gap={16}>
      <H2>{epic?.name || 'Epic Details'}</H2>
    </Flex>
  );
};
